import moment from 'moment';

import type { TimestampInMillis } from '@cobliteam/common-types';

export const maybeDateTimeStrToMilli = (
  date: string | null
): TimestampInMillis | undefined => {
  return (
    (date && moment(date, 'YYYY-MM-DD HH:mm:ss ZZ').valueOf()) || undefined
  );
};

export default maybeDateTimeStrToMilli;
